"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames4 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactInputMask = _interopRequireDefault(require("react-input-mask"));
var _Button = _interopRequireWildcard(require("../Button"));
var _Label = _interopRequireDefault(require("../Label"));
var _styles = _interopRequireDefault(require("./styles"));
var _clear = _interopRequireDefault(require("./clear.svg"));
var _arrow = _interopRequireDefault(require("./arrow.svg"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var StyledInput = _styledComponents.default.input(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    :hover,\n    :focus {\n        border-color: ", "\n    }\n"])), function (props) {
  return props.theme.primaryColor;
});
var Input = (0, _react.forwardRef)(function (_ref, ref) {
  var arrowIcon = _ref.arrowIcon,
    autoWidth = _ref.autoWidth,
    className = _ref.className,
    errorMsg = _ref.errorMsg,
    warningMsg = _ref.warningMsg,
    hasError = _ref.hasError,
    icon = _ref.icon,
    id = _ref.id,
    label = _ref.label,
    labelClassName = _ref.labelClassName,
    inputClassName = _ref.inputClassName,
    mask = _ref.mask,
    name = _ref.name,
    placeholder = _ref.placeholder,
    readOnly = _ref.readOnly,
    value = _ref.value,
    _onChange = _ref.onChange,
    onClear = _ref.onClear,
    onClick = _ref.onClick,
    onKeyPress = _ref.onKeyPress,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    autoFocus = _ref.autoFocus;
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    inputPlaceholderWidth = _useState2[0],
    setInputPlaceholderWidth = _useState2[1];
  var spanRef = (0, _react.useRef)();
  var commonInputProps = {
    autoFocus: autoFocus,
    id: id,
    name: name,
    placeholder: placeholder,
    readOnly: readOnly,
    ref: ref,
    type: 'text',
    className: (0, _classnames4.default)(_styles.default.input, inputClassName, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _styles.default.search, autoWidth), _styles.default.error, hasError), _styles.default.warning, Boolean(warningMsg)), _styles.default.pointer, !!arrowIcon)),
    style: {
      width: autoWidth ? inputPlaceholderWidth : undefined
    },
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  };
  var message = errorMsg || warningMsg;
  var onClickProxy = function onClickProxy(event) {
    if (onClick) {
      // because label will trigger a new click on input
      event.stopPropagation();
      event.preventDefault();
      onClick(event);
    }
  };
  (0, _react.useLayoutEffect)(function () {
    var spanNODE = spanRef.current;
    if (spanNODE && autoWidth) {
      setInputPlaceholderWidth(spanNODE.offsetWidth);
    }
  }, [autoWidth, value]);
  var input = /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames4.default)(_styles.default.root, className),
    onClick: onClickProxy
  }, autoWidth && /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.hiddenSearch,
    ref: spanRef
  }, value), mask ? /*#__PURE__*/_react.default.createElement(_reactInputMask.default, {
    alwaysShowMask: true,
    mask: mask,
    maskPlaceholder: placeholder,
    value: value,
    onBlur: onBlur,
    onChange: function onChange(e) {
      _onChange(e.target.value, e);
    },
    onFocus: onFocus,
    onKeyPress: onKeyPress
  }, /*#__PURE__*/_react.default.createElement(StyledInput, commonInputProps)) : /*#__PURE__*/_react.default.createElement(StyledInput, _extends({
    value: value,
    onBlur: onBlur,
    onChange: function onChange(e) {
      return _onChange(e.target.value, e);
    },
    onFocus: onFocus,
    onKeyPress: onKeyPress
  }, commonInputProps)), onClear && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.clearButtonWrapper
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    width: _Button.WIDTHS.FLUID,
    height: _Button.HEIGHTS.FLUID,
    icon: _clear.default,
    theme: _Button.THEMES.TRANSPARENT,
    onClick: onClear
  })), arrowIcon && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames4.default)(_styles.default.arrowIcon, _defineProperty({}, _styles.default.rotated, arrowIcon.rotated)),
    dangerouslySetInnerHTML: {
      __html: _arrow.default
    }
  }), icon && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.icon,
    dangerouslySetInnerHTML: {
      __html: icon
    }
  }), message && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames4.default)(_styles.default.message, _defineProperty(_defineProperty({}, _styles.default.isError, errorMsg), _styles.default.isWarning, warningMsg))
  }, message));
  return label ? /*#__PURE__*/_react.default.createElement(_Label.default, {
    className: labelClassName,
    text: label
  }, input) : input;
});
Input.propTypes = {
  arrowIcon: _propTypes.default.shape({
    rotated: _propTypes.default.bool
  }),
  autoWidth: _propTypes.default.bool,
  autoFocus: _propTypes.default.bool,
  className: _propTypes.default.string,
  errorMsg: _propTypes.default.string,
  warningMsg: _propTypes.default.string,
  hasError: _propTypes.default.bool,
  icon: _propTypes.default.string,
  id: _propTypes.default.string,
  label: _propTypes.default.string,
  labelClassName: _propTypes.default.string,
  inputClassName: _propTypes.default.string,
  mask: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
  name: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  readOnly: _propTypes.default.bool,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onClear: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onKeyPress: _propTypes.default.func,
  onMouseEnter: _propTypes.default.func,
  onMouseLeave: _propTypes.default.func
};
Input.displayName = 'Input';
var _default = exports.default = (0, _react.memo)(Input);